<template>
    <div class="fixed-left" :style="{ top: `${storeCommon.headerHeight}px` }" @click="onBackIndex"></div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { openWebview, closeWebview } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@qm-activity/common/store/common';
const storeCommon = useStoreCommon();

const onBackIndex = () => {
    if (storeCommon.urlParams.from === 'index') {
        closeWebview();
    } else {
        openWebview(`https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/index?full_screen=3`);
    }
};
</script>
<style lang="scss" scoped>
.fixed-left {
    position: absolute;
    top: 2px;
    left: 0;
    width: 48px;
    height: 164px;
    background: url('@divide/assets/images/divide_back@3x.png') no-repeat center/100% 100%;
}
</style>
